module.exports = __webpack_public_path__ + "img/Arrow_Left.e90a5747.svg";